import styled from "@emotion/styled";

export const StyleWrapper = styled.div<any>`
  padding: 16px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  background-color: ${(props: any) => props.theme.colors.white};
  ${(props: any) => props.stylewrapper}
`;
